import { UserItem } from './UserItem';

export function UsersList({ list }) {
  return list?.map((user) => <UserItem key={user.codigo_usuario} user={user} />);
}
